import { memo } from "react";
import { useTranslation } from "react-i18next";
import { AuraLayout, Layout, PageTitle, AddCardIcon } from "lola-framework-ui-test";

import { FlowHeroMark } from "../../components/FlowHeroMark";
import { ScrollFadeIndicator } from "../../components/ScrollFadeIndicator";
import { TITLE_COLOR } from "../../constants";
import { useStore } from "../../store/globalState";

/**
 * Card registration transition (gallery-safe). Static spinner — no tokenize
 * or register API.
 */
export const AddCardProcessingPage = memo(() => {
  const { t } = useTranslation("lola");
  const { theme } = useStore();
  const colorConfig = theme.whiteView;
  const { dropzoneColors, backgroundIcon } = colorConfig;

  return (
    <AuraLayout colorConfig={colorConfig} className="flow-landing-page">
      <Layout.Content className="landing-section flow-hero-section">
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />
        <section className="flow-hero">
          <FlowHeroMark
            showSpinner
            dropzoneColors={dropzoneColors}
            backgroundIcon={backgroundIcon}
          >
            <AddCardIcon size={60} colors={dropzoneColors} />
          </FlowHeroMark>
          <section className="landing-container">
            <PageTitle
              highlight={t("card.addingCard")}
              highlightColor={TITLE_COLOR}
              secudnary={t("card.pleaseWait")}
              secudnaryColor={TITLE_COLOR}
            />
          </section>
        </section>
      </Layout.Content>
    </AuraLayout>
  );
});
